import { useContext, useEffect } from 'react';
import { Lobby } from './Lobby';
import { SearchForms } from './SearchForms';
import { ResultPages } from './ResultsPages';
import { useParams } from 'react-router-dom';
import { SUPPLIERS_ID, SUPPLIERS_STEPS } from 'Enum/suppliers';
import {
  SuppliersContext,
  SuppliersResultsUrl,
} from 'Context/SuppliersContext';
import { TherapySuppliersProvider } from 'Context/SuppliersContext/TherapySuppliersContext';
import { DoctorsSuppliersProvider } from 'Context/SuppliersContext/DoctorsSuppliersContext';

export const SuppliersMain = () => {
  const { stepIndex, setStepIndex, suppliersId } = useContext(SuppliersContext);
  const { supplierCategory } = useParams();

  useEffect(() => {
    if (window.location.pathname.split('/').at(-1) !== SuppliersResultsUrl) {
      if (supplierCategory) setStepIndex(SUPPLIERS_STEPS.FORM);
      else setStepIndex(SUPPLIERS_STEPS.LOBBY);
    } else setStepIndex(SUPPLIERS_STEPS.RESULTS);
  }, [setStepIndex, supplierCategory]);

  const getContextWrapper = (children: React.ReactNode) => {
    switch (suppliersId) {
      default:
      case SUPPLIERS_ID.mentalTherapy:
        return <TherapySuppliersProvider>{children}</TherapySuppliersProvider>;
      case SUPPLIERS_ID.doctors:
        return <DoctorsSuppliersProvider>{children}</DoctorsSuppliersProvider>;
    }
  };

  const getStepContent = () => {
    switch (stepIndex) {
      default:
      case SUPPLIERS_STEPS.LOBBY:
        return <Lobby />;

      case SUPPLIERS_STEPS.FORM:
        return getContextWrapper(<SearchForms />);

      case SUPPLIERS_STEPS.RESULTS:
        return getContextWrapper(<ResultPages />);
    }
  };

  return getStepContent();
};
